module.exports = __webpack_public_path__ + "static/media/london_hornsoffa_djup_tyg_alis_320_detalj_2023_4.6c832e47.jpg";